const instrumentCheckpoint = () => {
	let lastSelectedAddressElement: HTMLSelectElement|null = null;
	const setupListener = () => {
		const changeListener = () => {
			lastSelectedAddressElement!.querySelectorAll("option").forEach(ele => {
				if (ele.selected) {
					const searchElement = document.getElementById("address-search") as HTMLInputElement;
					searchElement.value = ele.innerText.trim();
					(searchElement.form!.querySelector("input[type='submit']") as HTMLInputElement).click();
				}
			});
		};
		const currentSelectedAddressElement = document.getElementById("selectedAddress") as HTMLSelectElement;
		if (lastSelectedAddressElement !== currentSelectedAddressElement) {
			if (lastSelectedAddressElement !== null) {
				lastSelectedAddressElement.removeEventListener("change", changeListener);
			}
			lastSelectedAddressElement = currentSelectedAddressElement;
			if (lastSelectedAddressElement) {
				lastSelectedAddressElement.addEventListener("change", changeListener);
				changeListener();
			}
		}
	};
	const mutationObserver = new MutationObserver(setupListener);

	mutationObserver.observe(document, {childList: true, subtree: true});
};
export default instrumentCheckpoint;
